<template>
  <div>
    <profile-modal-base
      :is-open="showModal"
      @close="close"
    >
      <template #header>
        <profile-modal-header
          data-test="help-and-support-modal"
          :header-text="'Help & Support'"
          :back-target="'profileShowModal'"
        >
        </profile-modal-header>
      </template>
      <modal-row-group>
        <div
          class="flexbox-row button-row"
          data-test="support-email-row"
        >
          <span class="text-md font-medium">
            Email
          </span>
          <span class="flex-1"></span>
          <span class="text-sm font-regular">
            <a class="text-tertiary" :href="'mailto:' + email">
              {{ email }}
            </a>
            <span>
              <icon name="support"></icon>
            </span>
          </span>
        </div>
        <div
          class="flexbox-row button-row"
          data-test="support-phone-row"
        >
          <span class="text-md font-medium">
            Phone
          </span>
          <span class="flex-1"></span>
          <span class="text-sm font-regular">
            <a class="text-tertiary" :href="'tel:' + phone">
              {{ phone }}
            </a>
          </span>
          <span>
            <icon name="phone-uui"></icon>
          </span>
        </div>
        <button
          class="button-reset flexbox-row button-row"
          data-test="contact-support-row"
          @click="goto('support')"
        >
          <span class="text-md font-medium">
            Contact Support
          </span>
        </button>
      </modal-row-group>
      <modal-row-group>
        <button
          class="button-reset flexbox-row button-row"
          data-test="terms-and-conditions-row"
          @click="gotoURL('https://builtbyhlt.com/eula')"
        >
          <span class="text-md font-medium">
            Terms & Conditions
          </span>
        </button>
        <button
          class="button-reset flexbox-row button-row"
          data-test="privacy-policy-row"
          @click="gotoURL('https://builtbyhlt.com/privacy')"
        >
          <span class="text-md font-medium">
            Privacy Policy
          </span>
        </button>
      </modal-row-group>
    </profile-modal-base>
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon';
import ModalRowGroup from './ModalRowGroup.vue';
import ProfileModalBase from './ProfileModalBase.vue';
import ProfileModalHeader from './ProfileModalHeader.vue';
import ProfileModalMixin from '@/mixins/profileModal';

const MODAL_NAME = 'helpAndSupportModal';

export default {
  name: 'HelpAndSupportModal',
  components: {
    Icon,
    ModalRowGroup,
    ProfileModalBase,
    ProfileModalHeader,
  },
  mixins: [ProfileModalMixin],
  computed: {
    bundleIdentifier() {
      return this.$store.getters['app/bundleIdentifier'];
    },
    email() {
      return this.supportData?.email;
    },
    phone() {
      return this.supportData?.phone;
    },
    hours() {
      return this.supportData?.hours;
    },
    supportData() {
      const supportData = {
        'com.hltcorp.ase': {
          'phone': '1-703-669-6609',
          'email': 'contactus@ase.com',
          'hours': 'Available 8 a.m.-5 p.m. EST, Monday-Friday (except major U.S. holidays).',
        },
        'default': {
          'phone': '1-319-237-7162',
          'email': 'support@hltcorp.zendesk.com',
          'hours': 'Available 8 a.m.-6 p.m. CST, Monday-Friday (except major U.S. holidays).',
        },
      };
      if ( supportData[this.bundleIdentifier] ) {
        return supportData[this.bundleIdentifier];
      } else {
        return supportData['default'];
      }
    },
    showModal() {
      return this.$store.getters['ui/profileModalShown'] === MODAL_NAME;
    },
  },
  methods: {
    close() {
      this.$store.commit('ui/setProfileModalShown', '');
    },
    goto(route) {
      this.close();
      this.$router.push({name: route});
    },
    gotoURL(url) {
      window.open(url, '_blank');
    },
  },
};
</script>

<style scoped lang="scss">
.button-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: rem-calc(8);
  padding: 0 rem-calc(20);
  height: rem-calc(48);
}
</style>
